import { render, staticRenderFns } from "./PostPager.vue?vue&type=template&id=5add7388"
import script from "./PostPager.vue?vue&type=script&lang=js"
export * from "./PostPager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports